(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-benefits-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Initialize all instances (no Liquid in JS to satisfy theme-check)
  document.querySelectorAll('.ns-benefits-bar').forEach((root)=>{
    if(!root) return;

    const autoplay = root.dataset.autoplay === 'true';
    const interval = Math.max(1000, parseInt(root.dataset.interval || '5000', 10));

    const track   = root.querySelector('.ns-track');
    const slides  = root.querySelectorAll('.ns-slide');
    const prevBtn = root.querySelector('.ns-arrow--prev');
    const nextBtn = root.querySelector('.ns-arrow--next');

    let index = 0, timer;

    function go(i){
      if(!track || slides.length === 0) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    }

    function start(){
      if(!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(()=> go(index + 1), interval);
    }
    function stop(){
      if(timer){ clearInterval(timer); timer = null; }
    }

    prevBtn && prevBtn.addEventListener('click', ()=>{ stop(); go(index - 1); start(); });
    nextBtn && nextBtn.addEventListener('click', ()=>{ stop(); go(index + 1); start(); });

    track && track.addEventListener('mouseenter', stop);
    track && track.addEventListener('mouseleave', start);
    window.addEventListener('resize', ()=> go(index));

    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-board-advisors"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.ns-advisors');
  sections.forEach(function(sec){
    var track = sec.querySelector('.ns-advisors__grid');
    var hint  = sec.querySelector('.ns-advisors__hint');
    if(!track || !hint) return;

    function isMobile(){ return window.matchMedia('(max-width: 980px)').matches; }
    function updateHint(){
      if(!isMobile()) { hint.style.opacity = '0'; return; }
      var canScroll = track.scrollWidth > track.clientWidth + 8;
      hint.style.opacity = (canScroll && track.scrollLeft < 8) ? '1' : '0';
    }

    track.addEventListener('scroll', function(){
      if(track.scrollLeft > 8) hint.style.opacity = '0';
    }, { passive: true });

    window.addEventListener('resize', updateHint);
    updateHint();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-collection-pills"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // No Liquid here → theme-check OK
    const sectionEl = document.currentScript.closest('.shopify-section');
    if (!sectionEl) return;

    const list = sectionEl.querySelector('.ns-collection-pills__list');
    const pills = list ? Array.from(list.querySelectorAll('.ns-collection-pills__pill')) : [];

    const setActiveByPath = (path) => {
      let matched = false;
      pills.forEach(a => {
        const aPath = new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/+$/, '');
        const isActive = aPath === path;
        a.classList.toggle('is-active', isActive);
        a.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) matched = true;
      });
      if (!matched && pills.length) {
        pills.forEach(a => { a.classList.remove('is-active'); a.setAttribute('aria-selected', 'false'); });
        pills[0].classList.add('is-active'); pills[0].setAttribute('aria-selected', 'true');
      }
    };

    setActiveByPath(location.pathname.replace(/\/+$/, ''));

    list?.addEventListener('click', async (e) => {
      const a = e.target.closest('a.ns-collection-pills__pill');
      if (!a) return;
      e.preventDefault();

      const url = new URL(a.getAttribute('href'), location.origin);
      const sectionId = sectionEl.id.replace('shopify-section-', '');

      try {
        sectionEl.classList.add('is-loading');
        const res = await fetch(`${url.pathname}?sections=${encodeURIComponent(sectionId)}`, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const html = json[sectionId];
        if (!html) throw new Error('Section HTML not found');
        const mount = document.getElementById(`shopify-section-${sectionId}`);
        mount.innerHTML = html;
        history.pushState({}, '', url.pathname);
        requestAnimationFrame(() => {
          const newList = mount.querySelector('.ns-collection-pills__list');
          const newPills = newList ? Array.from(newList.querySelectorAll('.ns-collection-pills__pill')) : [];
          const curPath = location.pathname.replace(/\/+$/, '');
          newPills.forEach(a => {
            const aPath = new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/+$/, '');
            const isActive = aPath === curPath;
            a.classList.toggle('is-active', isActive);
            a.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        });
      } catch (err) {
        console.error('[NS Pills] Section render failed:', err);
      } finally {
        sectionEl.classList.remove('is-loading');
      }
    });

    window.addEventListener('popstate', async () => {
      const sectionId = sectionEl.id.replace('shopify-section-', '');
      const res = await fetch(`${location.pathname}?sections=${encodeURIComponent(sectionId)}`, { credentials: 'same-origin' });
      const json = await res.json();
      const html = json[sectionId];
      if (html) {
        document.getElementById(`shopify-section-${sectionId}`).innerHTML = html;
      } else {
        location.reload();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-faq-1"] && !Shopify.designMode) return;
  try {
    
/* NS FAQ — static accordion (no Liquid in this block) */
(function(){
  document.querySelectorAll('.ns-faq').forEach(function(root){
    var allowMulti = (root.dataset.allowMulti === 'true');
    var startFirst = (root.dataset.startFirstOpen === 'true');
    var items = root.querySelectorAll('.ns-item');

    items.forEach(function(item, idx){
      var btn = item.querySelector('.ns-q');
      var ans = item.querySelector('.ns-a');
      var inner = item.querySelector('.ns-a-inner');

      function open(){
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
        ans.style.blockSize = inner.scrollHeight + 'px';
      }
      function close(){
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded','false');
        ans.style.blockSize = 0;
      }

      btn.addEventListener('click', function(){
        var isOpen = item.classList.contains('is-open');
        if(!allowMulti){
          items.forEach(function(i){
            if(i!==item){
              i.classList.remove('is-open');
              var a=i.querySelector('.ns-a'); var b=i.querySelector('.ns-q');
              if(a) a.style.blockSize=0; if(b) b.setAttribute('aria-expanded','false');
            }
          });
        }
        isOpen ? close() : open();
      });

      if(startFirst && idx===0){ open(); }

      var rid;
      window.addEventListener('resize', function(){
        cancelAnimationFrame(rid);
        rid = requestAnimationFrame(function(){
          if(item.classList.contains('is-open')){
            ans.style.blockSize = inner.scrollHeight + 'px';
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
